import React, {Component} from 'react';
import Timeline from './Timeline';

export default class Who extends Component {

    constructor(props) {
        super(props);

        this.info = [
            {
                title: "Búsqueda",
                description: "Introduce las características del animal que estás buscando.",
                srcImageDescription: process.env.CDN_URL+"/images/adoptaunanimal/timelineWho/laptop.100x100.png"
                // srcImageDescription: getImageEncode("laptop.100x100")
            },
            {
                title: "Selección",
                description: "Puedes ver el detalle de cada perro y gato hasta que encuentres el deseado.",
                srcImageDescription: process.env.CDN_URL+"/images/adoptaunanimal/timelineWho/search.100x100.png"
                // srcImageDescription: getImageEncode("search.100x100")

            },
            {
                title: "Contacto con protectora",
                description: "Nosotros te facilitamos el contacto con la protectora para poder adoptarlo.",
                srcImageDescription: process.env.CDN_URL+"/images/adoptaunanimal/timelineWho/contactprotectora.100x100.png"
                // srcImageDescription: getImageEncode("contactprotectora.100x100")

            },
        ]
    }

    goToSearch() {
        let element_go = $("body");
        if (element_go.length !== 0) {
            //console.log("Haciendo scrollTop");
            $('body,html').stop(true, true).animate({                scrollTop: element_go.offset().top            }, 800);
        }
    }

    render() {
        return (
            // <div className="row" data-aos="fade-up" data-aos-duration="100">
            <div className="row" >
                <div className="col-lg-12">
                    <h6 className="title">¿Cómo funciona Adopta un Animal?</h6>
                    <Timeline
                        info = {this.info}
                    />
                    <a onClick={() => this.goToSearch()} href="#" className="btn btn-outline-secondary btn-get-started">Comenzar a buscar</a>
                </div>
            </div>
        );
    }

}
